import React, { useState, useEffect } from 'react';
import { View, Dimensions, Text, Animated, TouchableWithoutFeedback, Image } from 'react-native';
import { QLinearGradient, DeviceInfo } from 'qunar-react-native';
import { Button } from '@qnpm/q-components';
import { Shadow } from '@qnpm/q-shadow';
import Icon from '../Icon';
import styles from './style';
import { qav } from '../../Utils/qav';
import QImageSet from '../../assets/QImageSet.js';
import MemberPromotion from '../MemberPromotion';

interface Props {
    data?: any;
    marketing?: any;
    onRefresh?: any;
}

const MemberCard = (props: Props) => {
    let memberPromotionChild: any = null;
    const { isAndroid } = DeviceInfo;
    const [cardTitle, setCardTitle] = useState(props.data.foldDesc);
    const [rightsOpen, setRightsOpen] = useState(false);
    const [arrowDown, setscaleAnim] = useState(new Animated.Value(0));
    const [cardHeight, setCardHeight] = useState(new Animated.Value(0));
    const rotateZ = arrowDown.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '180deg']
    });

    useEffect(() => {
        if (props.data.memberShouldAnimate) {
            setTimeout(() => {
                memberCardDescClick(false);
                setTimeout(() => {
                    memberCardDescClick(true);
                }, 1500);
            }, 1000)
        }
    }, [])

    const memberCardDescClick = (current?: boolean) => {
        if (current === true || current === false) {
            if (!current) {
                cardOpenAnimate();
            } else {
                cardCloseAnimate();
            }
        } else {
            if (!rightsOpen) {
                cardOpenAnimate();
            } else {
                cardCloseAnimate();
            }
        }
    }

    const cardOpenAnimate = () => {
        const parallelAnimated = Animated.parallel([
            Animated.timing(arrowDown, {
                toValue: 1,
                duration: 150,
                useNativeDriver: true
            }),
            Animated.timing(cardHeight, {
                toValue: 1,
                duration: 150,
                useNativeDriver: false,
            })
        ]);
        parallelAnimated.start(() => {
            setCardTitle(props.data.unFoldDesc);
            setRightsOpen(true);
        })
    }

    const cardCloseAnimate = () => {
        const parallelAnimated = Animated.parallel([
            Animated.timing(arrowDown, {
                toValue: 0,
                duration: 150,
                useNativeDriver: true
            }),
            Animated.timing(cardHeight, {
                toValue: 0,
                duration: 150,
                useNativeDriver: false
            })
        ]);
        parallelAnimated.start(() => {
            setCardTitle(props.data.foldDesc);
            setRightsOpen(false);
        })
    }

    const getButton = (data: any, size: string) => {
        let button = undefined;
        switch (data.privilegeStatus) {
            case 'TO_USE':
                button = <Button
                    text={<Text style={[styles.buttonText, { color: '#FFFFFF' }]}>{data.privilegeDesc}</Text>}
                    needGradient={true}
                    gradientColors={["#D4ABFB", "#BA85FF"]}
                    size={size}
                    onPress={() => buttonPress('TO_USE', data.jumpUrl)}
                />
                break;
            case 'FLIGHT_TO_BIND':
                button = <Button
                    text={<Text style={[styles.buttonText, { color: '#56427D' }]}>{data.privilegeDesc}</Text>}
                    outline
                    size={size}
                    customStyle={{ borderColor: '#56427D', borderWidth: 0.5 }}
                    onPress={() => buttonPress('FLIGHT_TO_BIND')}
                />
                break;
            case 'USED':
                button = <Button
                    text={<Text style={[styles.buttonText, { color: '#999999' }]}>{data.privilegeDesc}</Text>}
                    outline
                    size={size}
                    customStyle={{ borderColor: '#999999', borderWidth: 0.5 }}
                    disabled
                />
                break;
            default:
                break;
        }
        return button;
    };

    const buttonPress = (privilegeStatus: string, jumpUrl?: string) => {
        switch (privilegeStatus) {
            case 'TO_USE':
                Ext.Router.Bridge.sendScheme({
                    url: `${DeviceInfo.scheme}${jumpUrl}`
                }, () => null);
                break;
            case 'FLIGHT_TO_BIND':
                memberPromotionChild.onOpenDialog();
                break;
            default:
                break;
        }
    };
    const onRef = (ref: any) => {
        memberPromotionChild = ref;
    }
    // if (true) {
    //     return (
    //         <View
    //             style={styles.memberCard}
    //         >
    //             <View style={styles.memberCardTop}>
    //                 <View><Text>钻石会员专享</Text></View>
    //                 <View>
    //                     <Text
    //                         style={[styles.memberCardText, { color: '#000' }]}
    //                         numberOfLines={1}
    //                     >
    //                         绑定订单后即可扫码使用
    //                     </Text>
    //                 </View>
    //             </View>
    //         </View>
    //     )
    // }
    if (!props.data.detailList || props.data.detailList.length === 0) return null;
    return (
        <TouchableWithoutFeedback>
            <View>
                <QLinearGradient
                    style={styles.memberCard}
                    colors={['rgba(217,235,255,0.33)', 'rgba(235,211,252,0.33)']}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                >
                    <Animated.View style={{
                        overflow: 'hidden',
                        height: cardHeight.interpolate({
                            inputRange: [0, 1],
                            outputRange: [30, props.data.detailList.length > 1 ? (isAndroid ? 135 : 138) : 107]
                        }),
                        position: 'relative'
                    }}>
                        <Image source={{ uri: QImageSet.member_card_line }} style={styles.memberCardLine} />
                        <TouchableWithoutFeedback onPress={memberCardDescClick}>
                            <View style={styles.memberCardTop}>
                                <Image source={{ uri: QImageSet.member_card_icon }} style={styles.memberCardIcon} />
                                <View style={styles.memberCardDesc}>
                                    <Text
                                        style={[styles.memberCardText, { color: '#56427D' }]}
                                        numberOfLines={1}
                                    >
                                        {cardTitle}
                                    </Text>
                                    <Icon
                                        code="&#xe55f;"
                                        animatable
                                        style={[styles.arrow, {
                                            transform: [{ rotateZ }]
                                        }]}
                                    />
                                </View>
                            </View>
                        </TouchableWithoutFeedback>
                        {
                            rightsOpen
                            &&
                            <View>
                                {
                                    props.data.detailList.length > 1
                                        ?
                                        <View style={[styles.memberCardBottom, { justifyContent: props.data.detailList.length === 2 ? 'flex-start' : 'space-between' }]}>
                                            {
                                                props.data.detailList.map((i: any, index: number) => (
                                                    <Shadow
                                                        //shadow={"shadow2"}
                                                        style={styles.memberCardRightsShadow}
                                                        key={index}
                                                    >
                                                        <View style={styles.memberCardRights}>
                                                            <Text
                                                                numberOfLines={1}
                                                                style={[styles.rightsText, { color: i.privilegeStatus === 'USED' ? '#999999' : '#333333' }]}
                                                            >
                                                                {i.privilegeName}
                                                            </Text>
                                                            <View style={styles.rightsPriceView}>
                                                                <Text style={[styles.rightsPriceLeft, { color: i.privilegeStatus === 'USED' ? '#999999' : '#FF6600' }]}>免费</Text>
                                                                <Text style={styles.rightsPriceRight} numberOfLines={1}>{i.subTitle}</Text>
                                                            </View>
                                                            {getButton(i, "mini")}
                                                        </View>
                                                    </Shadow>
                                                ))
                                            }
                                        </View>
                                        :
                                        <View style={{ paddingVertical: 4 }}>
                                            <Shadow
                                                //shadow={"shadow2"}
                                                style={[styles.memberCardRightsShadow]}
                                            >
                                                <View style={styles.memberCardRightsOnce}>
                                                    <View>
                                                        <Text
                                                            style={[styles.rightsTextOnce, { color: props.data.detailList[0].privilegeStatus === 3 ? '#999999' : '#333333' }]}
                                                        >
                                                            {props.data.detailList[0].privilegeName}
                                                        </Text>
                                                        <View style={styles.rightsPriceViewOnce}>
                                                            <Text style={[styles.rightsPriceLeftOnce, { color: props.data.detailList[0].privilegeStatus === 3 ? '#999999' : '#FF6600' }]}>免费</Text>
                                                            <Text style={styles.rightsPriceRightOnce}>{props.data.detailList[0].subTitle}</Text>
                                                        </View>
                                                    </View>
                                                    {getButton(props.data.detailList[0], "mini")}
                                                </View>
                                            </Shadow>
                                        </View>
                                }
                            </View>
                        }
                    </Animated.View>
                </QLinearGradient>
                {
                    Boolean(props.marketing)
                    &&
                    <MemberPromotion marketing={props.marketing} orderNo={props.data.flightOrderNo} onRef={onRef} onRefresh={props.onRefresh} />
                }
            </View>
        </TouchableWithoutFeedback>
    );
};

export default MemberCard;
